import {Component, computed, input, output, Signal} from '@angular/core';

import {SvgSpriteIcon} from '@selpia/shared/ui';
import {DimensionItem, DimensionLevel} from '@selpia/shared/models';
import {AnalyticsDirective} from '@selpia/user/tracking';


export interface DrilldownTarget {
  targetLevel: DimensionLevel;
  dimensionItems: DimensionItem[];
}

export interface DrilldownItem {
  dimensionName: string;
  nextLevel: DimensionLevel | undefined;
}

@Component({
  selector: 'lib-drilldown',
  standalone: true,
  imports: [AnalyticsDirective],
  templateUrl: './drilldown.component.html',
  styleUrl: './drilldown.component.scss',
})
export class DrilldownComponent {
  readonly dimensionItems = input.required<DimensionItem[]>();

  drillDown = output<DrilldownTarget>();

  protected readonly drilldownItems: Signal<DrilldownItem[]> = computed(() =>
    this.#getTargetItems(this.dimensionItems()),
  );

  handleDrilldown(targetLevel: DimensionLevel | undefined) {
    if (targetLevel) {
      this.drillDown.emit({targetLevel, dimensionItems: this.dimensionItems()});
    }
  }

  #getTargetItems(items: DimensionItem[]): DrilldownItem[] {
    return items.map(item => {
      const dimensionName = item.dimension.name;

      const nextLevel = item.dimension.levels.find(level => level.levelNumber - 1 === item.dimensionLevel?.levelNumber);

      return {nextLevel, dimensionName};
    });
  }

  protected readonly SvgSpriteIcon = SvgSpriteIcon;
}
